export const BackgroundElements = () => {
  return (
    <div className="absolute inset-0">
      <div
        className="absolute animate-float -top-1/3 -right-1/3 w-[800px] h-[800px] bg-primary/10 rounded-full blur-3xl"/>
      <div
        className="absolute animate-float -bottom-1/3 -left-1/3 w-[800px] h-[800px] bg-highlight/10 rounded-full blur-3xl"/>
    </div>
  );
};